export default [
  {
    path: '/integrations',
    name: 'Integrations',
    component: () => import(/* webpackChunkName: "integrations" */ '@/views/integrations/Main.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: false,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'Integrations',
      requireAuth: true,
      requireAccount: true,
      title: 'Integraciones'
    }
  },
  {
    path: '/integrations/billers/built_in',
    name: 'BillersBuiltInSettings',
    component: () => import(/* webpackChunkName: "integrations" */ '@/views/integrations/billers/built_in/Settings.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: false,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'Integrations',
      requireAuth: true,
      requireAccount: true,
      title: 'Facturador'
    }
  },
  {
    path: '/integrations/billers/built_in/rvds',
    name: 'BillersBuiltInRvds',
    component: () => import(/* webpackChunkName: "integrations" */ '@/views/integrations/billers/built_in/ReportRvds.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: false,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'Integrations',
      requireAuth: true,
      requireAccount: true,
      title: 'Reporte RVD'
    }
  },
  {
    path: '/integrations/billers/built_in/transactional',
    name: 'BillersBuiltInReportTransactional',
    component: () => import(/* webpackChunkName: "integrations" */ '@/views/integrations/billers/built_in/ReportTransactional.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: false,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'Integrations',
      requireAuth: true,
      requireAccount: true,
      title: 'Reporte transaccional'
    }
  },
  {
    path: '/integrations/b2brouter',
    name: 'IntegrationsB2BRouter',
    component: () => import(/* webpackChunkName: "integrations" */ '@/views/integrations/B2BRouter.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: false,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'Integrations',
      requireAuth: true,
      requireAccount: true,
      title: 'b2brouter - Integraciones'
    }
  },
  {
    path: '/integrations/defontana',
    name: 'IntegrationsDefontana',
    component: () => import(/* webpackChunkName: "integrations" */ '@/views/integrations/defontana/Main.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: false,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'Integrations',
      requireAuth: true,
      requireAccount: true,
      title: 'Defontana - Integraciones'
    }
  },
  {
    path: '/integrations/facturapi',
    name: 'IntegrationsFacturapi',
    component: () => import(/* webpackChunkName: "integrations" */ '@/views/integrations/facturapi/Main'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: false,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'Integrations',
      requireAuth: true,
      requireAccount: true,
      title: 'Facturapi - Integraciones'
    }
  },
  {
    path: '/integrations/nfe',
    name: 'IntegrationsNfe',
    component: () => import(/* webpackChunkName: "integrations" */ '@/views/integrations/nfe/Main'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: false,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'Integrations',
      requireAuth: true,
      requireAccount: true,
      title: 'NFE.io - Integraciones'
    }
  },
  {
    path: '/integrations/plemsi',
    name: 'IntegrationsPlemsi',
    component: () => import(/* webpackChunkName: "integrations" */ '@/views/integrations/Plemsi.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: false,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'Integrations',
      requireAuth: true,
      requireAccount: true,
      title: 'Plemsi - Integraciones'
    }
  },
  {
    path: '/integrations/billers/:id',
    name: 'BillersBiller',
    component: () => import(/* webpackChunkName: "integrations" */ '@/views/integrations/billers/Biller.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: false,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'Integrations',
      requireAuth: true,
      requireAccount: true,
      title: 'Facturador'
    }
  },
  {
    path: '/integrations/santander-brasil',
    name: 'SantanderBrasil',
    component: () => import(/* webpackChunkName: "integrations" */ '@/views/integrations/SantanderBrasil.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: false,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'Integrations',
      requireAuth: true,
      requireAccount: true,
      title: 'Santander Brasil - Integraciones'
    }
  },
  {
    path: '/integrations/getnet',
    name: 'Getnet',
    component: () => import(/* webpackChunkName: "integrations" */ '@/views/integrations/Getnet.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: false,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'Integrations',
      requireAuth: true,
      requireAccount: true,
      title: 'Getnet - Integraciones'
    }
  },
  {
    path: '/integrations/khipu',
    name: 'Khipu',
    component: () => import(/* webpackChunkName: "integrations" */ '@/views/integrations/Khipu.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: false,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'Integrations',
      requireAuth: true,
      requireAccount: true,
      title: 'Khipu - Integraciones'
    }
  },
  {
    path: '/integrations/mercadopago',
    name: 'MercadoPago',
    component: () => import(/* webpackChunkName: "integrations" */ '@/views/integrations/MercadoPago.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: false,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'Integrations',
      requireAuth: true,
      requireAccount: true,
      title: 'Mercado Pago - Integraciones'
    }
  },
  {
    path: '/integrations/oneclick',
    name: 'Oneclick',
    component: () => import(/* webpackChunkName: "integrations" */ '@/views/integrations/Oneclick.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: false,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'Integrations',
      requireAuth: true,
      requireAccount: true,
      title: 'Oneclick - Integraciones'
    }
  },
  {
    path: '/integrations/paypal',
    name: 'PayPal',
    component: () => import(/* webpackChunkName: "integrations" */ '@/views/integrations/PayPal.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: false,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'Integrations',
      requireAuth: true,
      requireAccount: true,
      title: 'PayPal - Integraciones'
    }
  },
  {
    path: '/integrations/stripe',
    name: 'Stripe',
    component: () => import(/* webpackChunkName: "integrations" */ '@/views/integrations/Stripe.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: false,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'Integrations',
      requireAuth: true,
      requireAccount: true,
      title: 'Stripe - Integraciones'
    }
  },
  {
    path: '/integrations/twocheckout',
    name: 'TwoCheckout',
    component: () => import(/* webpackChunkName: "integrations" */ '@/views/integrations/TwoCheckout.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: false,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'Integrations',
      requireAuth: true,
      requireAccount: true,
      title: '2Checkout - Integraciones'
    }
  },
  {
    path: '/integrations/webpay',
    name: 'Webpay',
    component: () => import(/* webpackChunkName: "integrations" */ '@/views/integrations/Webpay.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: false,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'Integrations',
      requireAuth: true,
      requireAccount: true,
      title: 'Webpay - Integraciones'
    }
  }
]